<template>
  <div class="history-list">
    <section class="data-table" :class="{loading: isLoading}">
      <section class="data-header">
        <div class="data-col col1">{{ $t('component.history.list.labelPaymentDate') }}</div>
        <div class="data-col col2">{{ $t('component.history.list.labelPhoneNumber') }}</div>
        <div class="data-col col3">{{ $t('component.history.list.labelTopupAmount') }}</div>
        <div class="data-col col4">{{ $t('component.history.list.labelTopupType') }}</div>
        <div class="data-col col5">{{ $t('component.history.list.labelTopupStatus') }}</div>
        <div class="data-col col6">{{ $t('component.history.list.labelPaymentId') }}</div>
        <div class="data-col col7">{{ $t('component.history.list.labelPaymentStatus') }}</div>
        <div class="data-col col8"></div>
      </section>
      <section class="data-content">
        <div class="data-row" v-for="(item, index) in items" :key="index">
          <div class="data-col col1">
            <div class="label-mobile">{{ $t('component.history.list.labelPaymentDate') }}:</div>
            {{ item.date }}
          </div>
          <div class="data-col col2">
            <div class="label-mobile">{{ $t('component.history.list.labelPhoneNumber') }}:</div>
            {{ item.msisdn | phone }}
          </div>
          <div class="data-col col3">
            <div class="label-mobile">{{ $t('component.history.list.labelTopupAmount') }}:</div>
            {{ item.amount | pln }} zł
          </div>
          <div class="data-col col4">
            <div class="label-mobile">{{ $t('component.history.list.labelTopupType') }}:</div>
            <el-tooltip v-if="isTopupTypeRecurring(item.type)" :content="$t('component.history.list.tooltipTopupAuto')" placement="top" :hide-after="1000">
              <i class="el-icon-refresh"></i>
            </el-tooltip>
            <el-tooltip v-if="isTopupTypeSingle(item.type)" :content="$t('component.history.list.tooltipTopupSingle')" placement="top" :hide-after="1000">
              <i class="el-icon-right"></i>
            </el-tooltip>
          </div>
          <div class="data-col col5">
            <div class="label-mobile">{{ $t('component.history.list.labelTopupStatus') }}:</div>
            <span :class="getTopupStatusTagClass(item.status)">
              {{ getTopupStatusTagDesc(item.status) }}
            </span>
          </div>
          <div class="data-col col6">
            <div class="label-mobile">{{ $t('component.history.list.labelPaymentId') }}:</div>
            {{ item.paymentId }}
          </div>
          <div class="data-col col7">
            <div class="label-mobile">{{ $t('component.history.list.labelPaymentStatus') }}:</div>
            <span :class="getPaymentStatusTagClass(item.paymentStatus)">
              {{ getPaymentStatusTagDesc(item.paymentStatus) }}
            </span>
          </div>
          <div class="data-col col8">
            <el-tooltip v-if="isTopupTypeSingle(item.type)" :content="$t('component.history.list.tooltipTopupAgain')" placement="top" :hide-after="1000">
              <el-button type="primary" icon="el-icon-refresh-right" plain size="mini" @click="topupAgain(item)"
                         :title="$t('component.history.list.a11y.topupButton')"></el-button>
            </el-tooltip>
          </div>
        </div>
      </section>
    </section>
  </div>
</template>

<script>
import HistoryListMixin from '@/common/mixins/History/List.mixin'

export default {
  name: 'HistoryList',
  mixins: [HistoryListMixin]
}
</script>
<style src="../../assets/scss/table.scss" lang="scss"></style>
<style lang="scss">
@import '../../assets/scss/variables';
.history-list {
  @media (min-width: $res-m) {
    .col1 { width: 120px }
    .col2 { width: 90px }
    .col3 { width: 60px }
    .col4 { width: 40px }
    .col5 { width: 130px }
    .col6 { width: 40px }
    .col7 { width: 100px }
    .col8 { width: 50px }
  }
  @media (min-width: $res-l) {
    .col1 { width: 140px }
    .col2 { width: 100px }
    .col3 { width: 80px }
    .col4 { width: 50px }
    .col5 { width: 160px }
    .col6 { width: 40px }
    .col7 { width: 180px }
    .col8 { width: 50px }
  }
  @media (min-width: $res-xl) {
    .col1 { width: 160px }
    .col2 { width: 120px }
    .col3 { width: 100px }
    .col4 { width: 60px }
    .col5 { width: 160px }
    .col6 { width: 60px }
    .col7 { width: 200px }
    .col8 { width: 50px }
  }
}
</style>
